/**
 * The knowledge library's document categories, labelled in the active
 * language. Config-driven (app.yaml `knowledge_base.categories`); empty until
 * the config has loaded. Every surface that files a new document (the upload
 * page, the Studio's written process) reads them here.
 */
import { useMemo } from 'react';

import { useActiveLanguage, useConfigStore } from '@/stores/config';
import type { DocumentCategory } from '@/api/endpoints/documents';

export interface KnowledgeCategoryOption {
  value: DocumentCategory;
  label: string;
}

export function useKnowledgeCategories(): KnowledgeCategoryOption[] {
  const categories = useConfigStore((s) => s.config?.knowledge_base?.categories);
  const lang = useActiveLanguage();
  return useMemo(
    () =>
      (categories ?? []).map((c) => ({
        value: c.key,
        label: lang === 'de' ? c.label_de : c.label_en,
      })),
    [categories, lang],
  );
}
